import { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/auth-context';

export function AuthRedirector() {
  const { authRedirectPathRef, setAuthRedirectPath } = useContext(AuthContext);
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    const target = authRedirectPathRef.current;
    if (target && loc.pathname === '/') {
      nav(target, { replace: true });
      setAuthRedirectPath(null);
    }
  }, [loc, nav, setAuthRedirectPath, authRedirectPathRef]);
  return null;
}
